import { render, staticRenderFns } from "./JsonItem.vue?vue&type=template&id=287c1f4c&scoped=true&"
import script from "./JsonItem.vue?vue&type=script&lang=js&"
export * from "./JsonItem.vue?vue&type=script&lang=js&"
import style0 from "./JsonItem.vue?vue&type=style&index=0&id=287c1f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287c1f4c",
  null
  
)

export default component.exports